$('.featured-thought-item').slick({
  fade: false,
  arrows: true,
});
